module.exports = __webpack_public_path__ + "static/taxitronic-MONEI-cef99096f2bcd3129871b7018f35c52d.png";